// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/opt/build/repo/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-vehicle-showcase-i-frame-js": () => import("/opt/build/repo/src/pages/VehicleShowcaseIFrame.js" /* webpackChunkName: "component---src-pages-vehicle-showcase-i-frame-js" */)
}

